<template>
    <v-container fluid class="pt-0">
        <create-or-update-holiday
            :is-open="isCreateOrUpdateDialogVisible"
            :holiday="selected"
            @close="onCloseCreateOrUpdateDialog"
        />
        <confirm-delete
            :is-open="isConfirmDeleteDialogVisible"
            :selected="selected"
            @confirm="onConfirmDeleteDialog"
            @close="onCloseConfirmDeleteDialog"
        />
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h1>{{ $t('holidaysView.title') }}</h1>
                            </v-col>
                            <v-col v-if="isAdmin" cols="12" sm="6" md="9">
                                <v-btn
                                    depressed
                                    medium
                                    class="mt-2"
                                    @click="onOpenCreateOrUpdateDialog(false)"
                                    >{{ $t('holidaysView.newHoliday') }}</v-btn
                                >
                            </v-col>
                            <import-from-csv
                                v-if="isAdmin"
                                @upload="onCsvUpload"
                            />
                        </v-row>
                        <holiday-list
                            :holidays="holidaysForYear"
                            :visibilityConfig="{
                                actions: {
                                    edit: true,
                                    delete: true
                                },
                                excludeHeaders: isAdmin ? null : ['action']
                            }"
                            @edit="onOpenCreateOrUpdateDialog"
                            @delete="onDeleteItem"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';

export default {
    name: 'holidays',
    components: {
        HolidayList: () => import('@/components/HolidayList'),
        CreateOrUpdateHoliday: () =>
            import('@/components/CreateOrUpdateHoliday'),
        ConfirmDelete: () => import('@/components/ConfirmDelete'),
        ImportFromCsv: () => import('@/components/ImportFromCsv')
    },
    data() {
        return {
            isCreateOrUpdateDialogVisible: false,
            isConfirmDeleteDialogVisible: false,
            selected: null
        };
    },
    computed: {
        ...mapGetters({
            holidaysForYear: 'holidays/getHolidaysForYear',
            isAdmin: 'auth/isAdmin'
        })
    },
    methods: {
        ...mapActions({
            importCsv: 'holidays/importCsv',
            deleteHoliday: 'holidays/delete'
        }),

        onDeleteItem(item = {}) {
            this.selected = item;
            this.isConfirmDeleteDialogVisible = true;
        },
        async onConfirmDeleteDialog(item) {
            try {
                await this.deleteHoliday(item);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('holidaysView.holidayTitle'),
                    text: this.$t('holidaysView.deleteSuccess')
                });
            } catch (error) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('holidaysView.holidayTitle'),
                    text: this.$t('holidaysView.deleteError')
                });

                console.error(error);
            }

            this.onCloseConfirmDeleteDialog();
        },
        onCloseConfirmDeleteDialog() {
            this.selected = {};
            this.isConfirmDeleteDialogVisible = false;
        },
        onOpenCreateOrUpdateDialog(item = {}) {
            this.isCreateOrUpdateDialogVisible = true;

            if (item.id) {
                this.selected = item;
            }
        },
        onCloseCreateOrUpdateDialog() {
            this.selected = {};
            this.isCreateOrUpdateDialogVisible = false;
        },
        async onCsvUpload(csvFile) {
            try {
                await this.importCsv(csvFile);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('importFromCsv.csvUploadForm.uploadTitle'),
                    text: this.$t('importFromCsv.csvUploadForm.uploadSuccess')
                });
            } catch (error) {
                console.error(error);

                if (
                    error &&
                    error.response &&
                    error.response.status === StatusCodes.BAD_REQUEST
                ) {
                    this.csvName = '';

                    return this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t(
                            'importFromCsv.csvUploadForm.uploadTitle'
                        ),
                        text: this.$t(
                            'importFromCsv.csvUploadForm.incorrectCsv'
                        )
                    });
                }

                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('importFromCsv.csvUploadForm.uploadTitle'),
                    text: this.$t('formCommonErrors.serverError')
                });
            }
        }
    }
};
</script>
